import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capital'
})
export class CapitalPipe implements PipeTransform {
  private readonly valMap = { 
    OF : 'of', 
    AND : 'and', 'AND/OR': 'and/or', 
    THE: 'the', 
    DA : 'da', 'U.S.' : 'U.S.', 
    US : 'US',
    DE : 'de',
    AT : 'at', 
    OR : 'or', 
    TO : 'to' , 
    NPI : 'NPI'
  };

  transform(value: string): any {
    return value.length === 0 ? '' :
      value.replace(/\w\S*/g, 
        (txt => this.valMap[txt] ? 
          this.valMap[txt] : 
          txt[0].toUpperCase() + txt.substr(1).toLowerCase()
        )
      );
  }
}
